import classNames from 'classnames';
import PropTypes from 'prop-types';

function ColorPickerButton(props) {
  const {
    children,
    id,
    color,
    onClick,
    disabled = false,
    transparent = false,
    tabIndex,
  } = props;

  const isCleared = (color === undefined);

  return (
    <button
      id={id}
      className={classNames(
        'w-11 h-7 p-1 rounded-sm relative',
        {
          'border-2 border-pxPrimary cursor-pointer': !disabled,
          'border border-pxOutlineStrong/80': disabled,
          'bg-white': !transparent,
          'bg-transparent': transparent,
        },
      )}
      onClick={onClick}
      type="button"
      tabIndex={tabIndex}
    >
      <div
        className="w-full h-full rounded-xs relative"
        style={{
          background: isCleared ? '#FFFFFF' : color,
        }}
      >
        {isCleared && (
          <>
            <div
              className="absolute bg-pxBgMuted"
              style={{
                width: '1px',
                height: '141%',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%) rotate(45deg)',
              }}
            />
            <div
              className="absolute bg-pxBgMuted"
              style={{
                width: '1px',
                height: '141%',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%) rotate(-45deg)',
              }}
            />
          </>
        )}
      </div>

      {children}
    </button>
  );
}

ColorPickerButton.propTypes = {
  children: PropTypes.node,
  id: PropTypes.string,
  color: PropTypes.string,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  transparent: PropTypes.bool,
  tabIndex: PropTypes.number,
};

export default ColorPickerButton;
